import { useEffect, useRef } from 'react';
import type { AnonymousUser, LoggedInUser } from '../login/userContext';
import useUser from '../login/userContext';

/**
 * Calls the callback on mount, after the user context has settled
 */

export default function useOnMount(callback: (user: Readonly<LoggedInUser | AnonymousUser>) => void) {
    const userContext = useUser();
    const wasUndefined = useRef(true);

    useEffect(() => {
        if (userContext.isLoggedIn !== undefined && wasUndefined.current) {
            wasUndefined.current = false;
            callback(userContext);
        }
    }, [userContext.isLoggedIn]);
}
